export default __webpack_public_path__ + "static/media/ELECTIVE_HEALTH_PE.67a252ed.svg";